module.exports = __webpack_public_path__ + "media/images/download-app-icon-74ea8cde13dea4ba553e8b99e7ecfe59.svg";